<template>
    <v-flex>
        <v-layout row class="content-header">
            <v-flex md6 class="content-title">
                <h2>Notas Submetidas</h2>
                <h4>Pesquise e acompanhe os status de notas submetidas. </h4>
            </v-flex>
            <v-flex md4>
                    <v-text-field
                    v-model="termoPesquisa"
                    label="Pesquisa"
                    placeholder="Envio, Nota, Usuário, Data Tratamento e Status"
                    outlined
                    class="input-pesquisa"
                    @keyup.enter="pesquisar()"
                ></v-text-field>
            </v-flex>
            <v-flex md2>
                &nbsp;<v-btn color="info" @click="pesquisar()"><v-icon>mdi-magnify</v-icon></v-btn>
            </v-flex>
            <v-flex md12>
                <div class="line"></div>
            </v-flex>            
        </v-layout>
        <v-layout row class="content-body overflow-y-auto">
            <v-flex md12>
                <v-data-table
                    v-model="selecionado"
                    :headers="headers"
                    :items="notasFiscais"
                    :items-per-page="topItems"
                    :search="termoPesquisa"
                    :loading="loading"
                    item-key="ID"
                    @click:row="MostrarDetalhes"
                    loading-text="Carregando... Por favor aguarde."
                    no-data-text="Nenhuma informação encontrada"
                    no-results-text="Nenhuma informação encontrada"
                    :sort-by="['DataEnvio']"
                    :sort-desc="[true]"                              
                    justify="center" style="cursor:pointer;">

                    <template v-slot:item.lupa="{ item }">
                        <v-hover v-slot:default="{ hover }">
                            <v-icon>mdi-magnify</v-icon>
                        </v-hover>
                    </template>
                    <template v-slot:item.DescricaoStatus="{ item }">
                        <span class="alert alert-success" v-if="item.DescricaoStatus == 'Aprovada'">Aprovada</span>   
                        <strong class="alert alert-warning" v-if="item.DescricaoStatus == 'Recebida'">Recebida</strong>
                        <span class="alert alert-danger" v-if="item.DescricaoStatus == 'Rejeitada' || item.Status == 7">Rejeitada</span>
                    </template>

                    <template v-slot:item.detalhes="{ item }">
                        <v-icon>mdi-chevron-down</v-icon>
                    </template>
                </v-data-table>    
                <v-layout justify-end>
                    <v-dialog v-model="showDetail" persistent max-width="1000px" @click:outside="showDetail = false">
                        <v-card>
                            <v-overlay :value="fullLoading">
                                <v-progress-circular indeterminate size="64"></v-progress-circular>
                            </v-overlay>                      
                            <v-card-title>
                            <span class="headline">Dados da Nota Fiscal</span>
                            </v-card-title>
                            <v-card-text>
                                <v-divider></v-divider>
                                <div> <!-- CORPO DO MODAL -->
                                    <v-expansion-panels v-model="panel" multiple>
                                        <v-expansion-panel>
                                            <v-expansion-panel-header>Comissões</v-expansion-panel-header>
                                            <v-expansion-panel-content>
                                                <v-simple-table fixed-header height="200px">
                                                    <template v-slot:default>
                                                    <thead>
                                                        <tr>
                                                            <th>Pagamento</th>
                                                            <th>Tipo</th>
                                                            <th>Valor bruto</th>
                                                            <th>IRRF</th>
                                                            <th>INSS</th>
                                                            <th>ISS</th>
                                                            <th>Líquido</th>                                                    
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="item in comissoes" :key="item.numeroRecibo">
                                                            <td>{{ FormatarData(item.dataPagamento) }}</td>
                                                            <td>
                                                                <span v-if="item.tipoComissao == 'COR'">Corretagem</span>
                                                                <span v-if="item.tipoComissao == 'AGE'">Agenciamento</span>                                                        
                                                            </td>
                                                            <td>{{ FormatarValorMonetario(item.valorBruto) }}</td>
                                                            <td>{{ FormatarValorMonetario(item.impostoRendaRetido) }}</td>
                                                            <td>{{ FormatarValorMonetario(item.valorInss) }}</td>
                                                            <td>{{ FormatarValorMonetario(item.valorIss) }}</td>
                                                            <td>{{ FormatarValorMonetario(item.valorBruto - ( item.impostoRendaRetido + item.valorInss + item.valorIss )) }}</td>
                                                        </tr>   
                                                    </tbody>
                                                    <tfoot>
                                                        <tr>
                                                            <td class="text-left" colspan="2">TOTAL</td>
                                                            <td class="text-left">{{ ValorBrutoTotal }}</td>
                                                            <td class="text-left">{{ IrrfTotal }}</td>
                                                            <td class="text-left">{{ InssTotal }}</td>
                                                            <td class="text-left">{{ IssTotal }}</td>
                                                            <td class="text-left">{{ ValorLiquidoTotal }}</td>                                                     
                                                        </tr>
                                                    </tfoot>
                                                    </template>
                                                </v-simple-table>
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>  
                                        <v-expansion-panel>
                                            <v-expansion-panel-header>Nota Fiscal</v-expansion-panel-header>
                                            <v-expansion-panel-content>
                                                <div>
                                                    <v-layout row wrap>
                                                        <v-flex xs12 md5>
                                                            <v-btn color="info" style="margin-bottom:15px !important;" :disabled="!ViaPsi" @click="BaixarNotaFiscal()"><v-icon>mdi-arrow-down</v-icon>&nbsp; Nota Fiscal Anexada</v-btn>
                                                            <br /> 
                                                        </v-flex>                               
                                                    </v-layout>
                                                    <v-layout wrap justify-space-between>
                                                        <v-flex xs12 md5>
                                                            <v-text-field v-model="NumeroNota" label="Número da Nota Fiscal" :disabled="true"></v-text-field>
                                                            <v-text-field v-model="Irrf" label="IRRF Informado" v-formatMoney="money" return-masked-value :disabled="true"></v-text-field>
                                                            <v-text-field v-model="Iss" label="ISS Informado" v-formatMoney="money" return-masked-value :disabled="true"></v-text-field>
                                                            <v-text-field v-model="Status" label="Status" :disabled="true"></v-text-field>                                        
                                                        </v-flex>
                                                        <v-flex xs12 md5>                                
                                                            <v-text-field v-model="ValorBruto" label="Valor Bruto Informado" v-formatMoney="money" return-masked-value :disabled="true"></v-text-field>
                                                            <v-text-field v-model="Inss" label="INSS Informado" v-formatMoney="money" return-masked-value :disabled="true"></v-text-field>
                                                            <v-text-field v-model="ImpostoTotal" label="Imposto Total Informado" v-formatMoney="money" return-masked-value :disabled="true"></v-text-field>
                                                            <!-- <v-text-field v-model="Motivo" label="Motivo" :disabled="true"></v-text-field> -->
                                                            <v-textarea v-model="Motivo" label="Motivo" :disabled="true" rows="3"></v-textarea>
                                                        </v-flex>                                
                                                    </v-layout>                                            
                                                </div>                                        
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>                              
                                    </v-expansion-panels>
                                </div>
                            </v-card-text>
                            <v-card-actions fixed>
                            <v-spacer></v-spacer>
                            <v-btn color="red" text type="button" @click="showDetail = false">Fechar</v-btn>
                            </v-card-actions>
                        </v-card>      
                    </v-dialog>             

                    <v-overlay :value="fullLoading">
                        <v-progress-circular indeterminate size="64"></v-progress-circular>
                    </v-overlay>

                </v-layout>         
            </v-flex>
        </v-layout>
    </v-flex>    
</template>
<script>
    import Vue from 'vue'
    import { mapState, mapGetters } from 'vuex';
    import Helpers from "@/utilities/Helpers";

    export default {
        mixins: [Helpers],    
        data() {
            return {
                baseURL: Vue.prototype.$httpPortal.defaults.baseURL,
                selecionado : [],
                loading: true,
                fullLoading: false,
                topItems: 10,
                totalItems: 1000,
                offset: 1,
                options: {},
                showDetail: false,                                
                headers: [
                    {text: "Envio", value: "DataEnvioBr", sortable: true},
                    {text: "Nota", value: "NumeroNota", sortable: true},
                    {text: "Competência", value: "Periodo", sortable: true, filterable: false},
                    {text: "Dias de Pagamento", value: "DiaPagamento", sortable: false, filterable: false},
                    // {text: "CNPJ/CPF", value: "CnpjCpf"},
                    {text: "Usuário Responsável", value: "UsuarioEmail", sortable: true},
                    {text: "Tratado Pela Previsul", value: "DataTratamento", sortable: true},
                    {text: "Status", value: "DescricaoStatus", sortable: true},
                    {text: "Detalhes", value: "lupa", sortable: false},                    
                    // {text: "", value: "detalhes"}
                ],
                headersComissoes:[
                    {text: "Pagamento", value: "dataPagamento", sortable: false},
                    {text: "Tipo", value: "tipoComissao", sortable: false},
                    {text: "Valor Bruto", value: "valorBruto", sortable: false},
                    {text: "IRRF", value: "impostoRendaRetido", sortable: false},
                    {text: "INSS", value: "valorInss", sortable: false},
                    {text: "ISS", value: "valorIss", sortable: false},
                    {text: "Líquido", value: "valorLiquido", sortable: false},                    
                ],
                notasFiscais: [],
                comissoes: [],
                idNotaFiscal : 0,
                NumeroNota : null,
                ValorBruto : null,
                Irrf : null,
                Inss : null,
                Iss : null,
                ImpostoTotal : null,
                Status : null,
                Motivo : null,
                ViaPsi : false,
                money: {
                    prefix: "",
                    suffix: "",
                    thousands: ".",
                    decimal: ",",
                    precision: 2
                },
                panel: [1],
                ValorBrutoTotal : null,
                IrrfTotal : null,
                InssTotal : null,
                IssTotal : null,
                ValorLiquidoTotal : null,
                termoPesquisa: "",                                 
            }
        },
        methods : {
            CarregarNotaFiscalTotal()
            {
                // let codigoCorretor = this.usuario.codCorretor;
                // let url = "NotaFiscal/"+codigoCorretor;

                // Vue.prototype.$httpPortal.get(url)
                // .then(res => {
                //     this.totalItems = res.data;              
                // })
                // .catch(ex => {
                //     console.log(ex);
                //     this.showToast("error", "Erro", "Ocorreu um problema no carregamento");
                // });
            },

            CarregarNotasFiscais()
            {
                this.fullLoading = true;
                this.notasFiscais = [];     
                this.loading = true;
                //this.CarregarNotaFiscalTotal();
                let top = this.topItems;
                let skip = (this.offset * top) - top;
                let codigoCorretor = this.usuario.codCorretor;
                let url = "NotaFiscal/"+codigoCorretor;

                if(this.termoPesquisa != "")
                    url += "/"+this.termoPesquisa.split("/").join("_");
                                    
                Vue.prototype.$httpPortal.get(url)
                .then(res => {
                    this.notasFiscais = res.data;
                    console.log(res.data);

                    for(let index in this.notasFiscais)
                    {
                        this.notasFiscais[index].PeriodoData = new Date('01/' + this.notasFiscais[index].Periodo); 
                    }
                    this.loading = false;               
                    this.fullLoading = false;
                })
                .catch(ex => {
                    console.log(ex);
                    this.showToast("error", "Erro", "Ocorreu um problema no carregamento");
                    this.loading = false;
                    this.fullLoading = false;
                });
            },
            FormatarValorMonetario(valor)
            {
                return valor.toLocaleString('pt-br', {minimumFractionDigits: 2});
            },            
            MostrarDetalhes(item)
            {
                this.showDetail = true;
                this.fullLoading = true;
                this.comissoes = [];
                let codigoCorretor = this.usuario.codCorretor;
                this.idNotaFiscal = item.ID;
                let url = "NotaFiscal/detalhes/"+codigoCorretor+"/"+this.idNotaFiscal;
                Vue.prototype.$httpPortal.get(url)
                .then(res => {
                    this.comissoes = res.data.Comissoes;
                    this.NumeroNota  = res.data.NumeroNota;
                    this.ValorBruto = this.FormatarValorMonetario(res.data.ValorBruto);
                    this.Irrf = this.FormatarValorMonetario(res.data.ValorIrrf);
                    this.Inss = this.FormatarValorMonetario(res.data.ValorInss);
                    this.Iss = this.FormatarValorMonetario(res.data.ValorIss);
                    this.ImpostoTotal = this.FormatarValorMonetario(res.data.ImpostoTotal);
                    
                    if(res.data.Status == 0 || res.data.Status == 7)
                        this.Status = "Rejeitada";
                    
                    if(res.data.Status == 1)
                        this.Status = "Enviada";
                        
                    if(res.data.Status == 2)
                        this.Status = "Recebida";                        

                    this.Motivo = res.data.Motivo;
                    this.ViaPsi = res.data.ViaPsi;
                    this.ValorBrutoTotal = 0;
                    this.IrrfTotal = 0;
                    this.InssTotal = 0;
                    this.IssTotal = 0;
                    this.ValorLiquidoTotal = 0;                                          
                    for(let i = 0; i < this.comissoes.length; i++)
                    {
                        this.ValorBrutoTotal = this.ValorBrutoTotal + this.comissoes[i].valorBruto;
                        this.IrrfTotal = this.IrrfTotal + this.comissoes[i].impostoRendaRetido;
                        this.InssTotal = this.InssTotal + this.comissoes[i].valorInss;
                        this.IssTotal = this.IssTotal + this.comissoes[i].valorIss;
                        this.ValorLiquidoTotal = this.ValorLiquidoTotal + (this.comissoes[i].valorBruto - (this.comissoes[i].impostoRendaRetido + this.comissoes[i].valorInss + this.comissoes[i].valorIss));                        
                    }

                        this.ValorBrutoTotal = this.FormatarValorMonetario(this.ValorBrutoTotal);
                        this.IrrfTotal = this.FormatarValorMonetario(this.IrrfTotal);
                        this.InssTotal = this.FormatarValorMonetario(this.InssTotal);
                        this.IssTotal = this.FormatarValorMonetario(this.IssTotal);
                        this.ValorLiquidoTotal = this.FormatarValorMonetario(this.ValorLiquidoTotal);                        


                    //console.log(res.data);
                    this.fullLoading = false;               
                })
                .catch(ex => {
                    console.log(ex);
                    this.showToast("error", "Erro", "Ocorreu um problema no carregamento");
                    this.fullLoading = false;
                });                
            },
            BaixarNotaFiscal()
            {
                if(this.showDetail == true)
                {
                    let codigoCorretor = this.usuario.codCorretor;
                    let url = this.baseURL + "Emissao/NotaFiscal/" + codigoCorretor+"/"+ this.idNotaFiscal;

                    window.open(url, "_blank");
                }
            },
            pesquisar()
            {
                this.CarregarNotasFiscais();
                this.termoPesquisa = '';
            },                        
        },
    watch: {
        options(value){
            if(this.offset != value.page)
            {
                value.itemsPerPage = value.itemsPerPage < 0 ? this.totalItems : value.itemsPerPage;
                this.offset = value.page
                this.topItems = value.itemsPerPage
                this.CarregarNotasFiscais()
            }
        }        
    },        
    computed: {
    ...mapGetters("usuarioModule", { usuario: "getUserInfo" })
    },
    mounted(){            
        this.CarregarNotasFiscais();
    },                       
}
</script>
